
// SPLIDE
// import '@splidejs/splide/css';
// Or Only core
//import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';
// AutoScroll Extension
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const Carousels = () => {
  // Splide
  const splides = document.querySelectorAll('.pf_splide');

  if (splides && splides.length > 0) {
    splides.forEach(splide => {
      initSlider(splide);
    });
  }

  function initSlider(splide) {
    // Get data attribute for variants
    const variant = splide.dataset.variant;

    // Declare `options` once
    let options = {};

    // Set the options based on the variant
    switch (variant) {
      case 'autoplay':
        options = { type: 'loop', autoplay: true, perPage: 1, pagination: false };
        new Splide(splide, options).mount();
        break;
      case 'autoscroll':
        options = {type: 'loop', drag: 'free', focus: 'center', perPage: 3, autoWidth: false, pagination: false, arrows: false, autoScroll: { pauseOnHover: false, speed: 1 }};
        new Splide(splide, options).mount({ AutoScroll });
        break;
      case 'wordswap':
        options = {type: 'fade', autoplay: true, interval: 3000, rewind: true, pagination: true, arrows: true};
        const splideInstance = new Splide(splide, options).mount();
        // Add animation triggers specific to the 'wordswap' variant
        splideInstance.on('mounted move', () => {
          animateCurrentSlide(splideInstance);
        });
        splideInstance.on('mounted', () => {
          animateCurrentSlide(splideInstance, true);
        });
        splideInstances[splideId] = splideInstance;
        break;
      default:
        new Splide(splide).mount();
    }
  }

  // Set titles up for animation
  function animateCurrentSlide(splideInstance) {
    const currentSlide = splideInstance.Components.Elements.slides[splideInstance.index];
    const slideText = currentSlide.textContent || '';
    const words = slideText.split(/\s+/);

    currentSlide.innerHTML = '';
    const maskContainer = document.createElement('div');
    maskContainer.style.overflow = 'hidden';
    currentSlide.appendChild(maskContainer);

    words.forEach(word => {
      if (word.trim().length > 0) {
        const span = document.createElement('span');
        span.textContent = word;
        span.style.display = 'inline-block';
        span.style.opacity = 0;
        maskContainer.appendChild(span);
        maskContainer.appendChild(document.createTextNode(' '));
      }
    });

    // Animate words using GSAP
    gsap.fromTo(maskContainer.querySelectorAll('span'), {
      opacity: 0,
      y: 30
    }, {
      opacity: 1,
      y: 0,
      duration: 0.4,
      stagger: 0.1,
      ease: 'power2.out'
    });
  }
};

export default Carousels;
